<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            title="Удаление бренда"
            btn-save-title="Удалить бренд"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            Бренд
            {{ getNameById(brands, 'BrandName', 'BrandID', brandId) }} будет
            удален из списка ваших брендов.
            <template v-if="productsCount > 0">
                <div class="mt-16 text-bold">
                    Выберите, что нам сделать с привязанными к данному бренду
                    изделиями.
                </div>

                <div class="cabinet-form-group">
                    <label class="custom-radio"
                        ><input
                            v-model="deletingType"
                            type="radio"
                            name="deletingType"
                            :value="1"
                        />
                        <span class="custom-radio__checkmark"></span>
                        Удалить все привязанные к бренду изделия
                    </label>
                </div>

                <div class="cabinet-form-group">
                    <label class="custom-radio"
                        ><input
                            v-model="deletingType"
                            type="radio"
                            name="deletingType"
                            :value="2"
                        />
                        <span class="custom-radio__checkmark"></span>
                        Привязать их к другому бренду
                    </label>
                    <div
                        class="product-form-visibility__descr"
                        :class="{
                            error:
                                $v.newBrandId.$dirty && $v.newBrandId.$invalid
                        }"
                    >
                        <label class="cabinet-form-group__label required"
                            >Бренд</label
                        >
                        <select-picker
                            :current-value="newBrandId"
                            :options="availableBrands"
                            key-value="BrandID"
                            key-title="BrandName"
                            select-title="Выберите"
                            :classes="['select', 'select--product-form']"
                            @onChange="onSelectPickerChange($event)"
                        />
                        <div
                            v-if="
                                $v.newBrandId.$dirty && $v.newBrandId.$invalid
                            "
                            class="error-label"
                        >
                            Поле необходимо заполнить
                        </div>
                    </div>
                </div>
                <div
                    v-if="$v.deletingType.$dirty && $v.deletingType.$invalid"
                    class="error-label"
                >
                    Выберите один из вариантов действий
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import SelectPicker from '@/components/Elements/SelectPicker'
import getNameById from '@/mixins/getNameById'
import { required, requiredIf } from 'vuelidate/lib/validators'

import { mapState, mapMutations, mapActions } from 'vuex'

const validations = {
    newBrandId: {
        required: requiredIf(function() {
            return this.deletingType == 2
        })
    },
    deletingType: {
        required: requiredIf(function() {
            return this.productsCount
        })
    }
}

export default {
    name: 'DeleteBrand',
    components: { Modal, SelectPicker },
    mixins: [getNameById],
    props: {
        brandId: {
            type: Number,
            required: true
        },
        productsCount: {
            type: Number,
            required: true
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            deletingType: '',
            newBrandId: ''
        }
    },
    computed: {
        ...mapState('supplierBrand', ['brands']),
        availableBrands() {
            return this.brands.filter(brand => brand.BrandID !== this.brandId)
        }
    },
    validations,
    methods: {
        ...mapMutations('supplierBrand', ['SET_ACTIVE_BRAND']),
        ...mapActions('supplierBrand', ['getBrands', 'deleteBrand']),
        closeModal() {
            this.$emit('closeModal')
        },
        onSelectPickerChange(val) {
            if (this.deletingType !== 2) this.deletingType = 2
            this.newBrandId = parseInt(val)
        },
        async saveModal() {
            if (this.loading) return

            if (this.brands.length <= 1) {
                this.$notify({
                    title: 'Невозможно удалить единственный бренд',
                    type: 'error'
                })
                return
            }

            this.$v.$touch()

            if (!this.$v.$invalid) {
                this.loading = true

                try {
                    let payload = {
                        brandId: this.brandId
                    }

                    if (this.deletingType === 2 && this.newBrandId) {
                        payload = {
                            ...payload,
                            data: {
                                NewBrandID: this.newBrandId
                            }
                        }
                    }

                    await this.deleteBrand(payload)

                    await this.getBrands()

                    if (window.$(window).width() < 768) {
                        window.$('#supplier-cabinet-back-brands').click()
                    }

                    this.SET_ACTIVE_BRAND(-1)

                    this.deletingType = ''
                    this.newBrandId = ''

                    this.$notify({
                        title: 'Бренд удален',
                        type: 'success'
                    })

                    this.$emit('deleteBrandSaved')
                } catch (e) {
                    console.log(e)
                    this.$notify({
                        title: 'Ошибка',
                        type: 'error'
                    })
                }

                this.loading = false
                this.closeModal()
            } else {
                this.$notify({
                    title: 'Форма заполнена некорректно',
                    type: 'error'
                })
            }
        }
    }
}
</script>
